import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import CustomFileInput from "../../../components/UI/PageInput/CustomFileInput";
import SelectedImagesBox from "../../../components/expense/add/SelectedImagesBox";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import SheetErrors from "../../../components/common/SheetErrors";
import SelectedExcelFile from "../../../components/UI/PageInput/SelectedExcelFile";
import SheetView from "../../../components/UI/viewDialogs/expense/SheetView";
import { getCompressImage } from "../../../functions/getCompressImage";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import { Download } from "lucide-react";

const UploadSheetsForm = ({
  isSucceed,
  sheetSetup,
  loading,
  sendData,
  responseData,
  isErrorSheetList,
  setErrorSheetList,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      pictures: [], // Initialize pictures as an empty array
      sheet: undefined,
    },
  });

  const pic = watch("pictures");
  const files = watch("files");
  const sheet = watch("sheet");
  const { append, remove } = useFieldArray({
    control,
    name: "files",
  });

  useEffect(() => {
    getCompressImage(pic, append);
  }, [pic]);

  const onSubmit = (data) => {
    sendData(data, reset);
  };

  return (
    <div className="form-container">
      <CenteredHeading title="Upload Sheets" />
      <form
        className="max-w-3xl mx-auto"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <CustomFileInput
          name="sheet"
          placeholder="Add File* (file format .xlsx)"
          accept=".xlsx, file/xlsx"
          register={{
            ...register("sheet", {
              required: "Please choose a file",
            }),
          }}
          setValue={setValue}
          multiple={true}
          error={errors.sheet}
        />
        {sheet && sheet[0]?.name && (
          <SelectedExcelFile
            selectedSheetName={sheet[0].name}
            removeSelectedFile={() => setValue("sheet", "")}
          />
        )}
        <CustomFileInput
          name="pictures"
          placeholder="Add Image* (jpg, png)"
          accept=".png, .jpg, image/png, image/jpeg"
          register={{
            ...register("pictures", {
              required: files
                ? files.length === 0
                  ? "Please choose a file"
                  : false
                : "Please choose a file",
            }),
          }}
          multiple={true}
          error={errors.pictures}
        />
        <SelectedImagesBox
          errors={errors.pictures}
          selectedImages={files}
          setValue={setValue}
          name="pictures"
          remove={remove}
        />
        <p className="pt-2">
          <SearchDropdown
            name="category_id"
            label="Category *"
            keyName="name"
            id="id"
            options={sheetSetup}
            control={control}
            selectedVal={watch("category_id")}
            setValue={setValue}
            error={errors.category_id}
          />
        </p>
        <div className="sheet-upload-btn-wrap">
          <PrimaryButton
            btnText={!loading ? "Upload Sheet" : "Adding..."}
            loading={loading}
            Icon={Download}
            size={20}
          />
          <GrayButton btnText="Clear" onClick={() => reset()} />
        </div>
      </form>
      {isErrorSheetList && (
        <SheetErrors
          errorList={responseData.sheetErrors}
          closeAction={() => setErrorSheetList(false)}
        />
      )}
      {isSucceed && (
        <SheetView
          viewDetails={responseData}
          successView={true}
          isLoaded={true}
        />
      )}
    </div>
  );
};

export default UploadSheetsForm;
